/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, FC } from "react";
import { TextField, Typography } from "@mui/material";
import { OnChangeInput } from "../../common/model/EventModels";

//TODO: rename state and userProfileData to something more descriptive
type Props = {
  onchange: OnChangeInput;
  onsubmit: any;
  setToggleState: (name: string, bool: boolean) => void;
  name: string;
  toggle: boolean;
  userProfileData: string;
  state: string;
};

const ProfileUsernameForm: FC<Props> = ({
  onchange,
  onsubmit,
  setToggleState,
  name,
  toggle,
  userProfileData,
  state
}) => {
  return (
    <Fragment>
      <div className="profile__userInfo">
        <span>{name.charAt(0).toUpperCase() + name.slice(1)}</span>
        <div className="profile__userInfo__container">
          {toggle ? (
            <form
              className="profile__userInfo__container__form"
              onSubmit={onsubmit(name)}
            >
                <TextField
                  type="text"
                  className="profile__userInfo__container__form__input"
                  onChange={onchange}
                  name={name}
                  error={state === ""}
                  defaultValue={state}
                  placeholder={
                    state === undefined || "" ? `Enter your ${name}` : ""
                  }
                />
              <button
                type="submit"
                className="profile__userInfo__container__form__btn"
              >
                Update
              </button>
            </form>
          ) : (
            <Fragment>
              <Typography variant="h6">
                {userProfileData
                  ? userProfileData
                  : `Link your ${name} account`}
              </Typography>
              <a
                onClick={() => {
                  setToggleState(name, true);
                }}
              >
                Edit
              </a>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ProfileUsernameForm;
